import styled from 'styled-components';

const LoaderWrapper = styled.div`
  text-align: center;

  img {
    width:  ${({ theme }) => theme.toRem(100)};
  }
`;

export { LoaderWrapper };
